<div class="mb-0 ml-6 mr-[54px] mt-1 flex h-6 items-center text-sm xl:mb-2 xl:mt-2 xl:text-base">
  @for (breadcrumb of breadcrumbs; track breadcrumb.href; let index = $index) {
    <div class="dashboard-breadcrumb-item" [ngClass]="{ 'item-last': index + 1 === breadcrumbs.length }">
      <a [routerLink]="breadcrumb.href">{{ breadcrumb.label | translate }}</a>

      @if (index + 1 !== breadcrumbs.length) {
        <ng-icon name="featherChevronRight" class="mx-2" color="#bfc6cc" />
      }
    </div>
  }
</div>
